// Paleta fixa de cores de vínculo (a chave é o que o backend guarda em vinculos.cor).
// Cada tom tem variante para o tema escuro. Os matizes evitam de propósito os das cores
// de status financeiro (verde = recebido, âmbar = aguardando NF, verde-água = a receber,
// vermelho = em atraso): a cor do vínculo só identifica o tomador, nunca o status.
const vinculoColorTokens = {
  "vinculo-blue": { default: "#2563eb", _dark: "#60a5fa" },
  "vinculo-orange": { default: "#ea580c", _dark: "#fb923c" },
  "vinculo-violet": { default: "#7c3aed", _dark: "#a78bfa" },
  "vinculo-brown": { default: "#8b5e3c", _dark: "#c8a27c" },
  "vinculo-pink": { default: "#db2777", _dark: "#f472b6" },
  "vinculo-slate": { default: "#64748b", _dark: "#94a3b8" },
  "vinculo-indigo": { default: "#4338ca", _dark: "#818cf8" },
  "vinculo-charcoal": { default: "#27272a", _dark: "#e4e4e7" },
};

export default vinculoColorTokens;
